module.exports = require('./helpers/bundle-url').getBundleURL('guoIO') + "logo.c51670a8.svg";